import { useEffect, useMemo, useState } from 'react';

const OPTION_FIELD_TYPES = ['multi_choice', 'checkbox', 'select'];

const getOptionValues = (settings) => {
  if (!Array.isArray(settings)) {
    return [''];
  }

  const optionValues = settings
    .map((option) => {
      if (typeof option === 'string') {
        return option;
      }

      if (option && typeof option === 'object') {
        return option.value || option.label || '';
      }

      return '';
    })
    .filter(Boolean);

  return optionValues.length ? optionValues : [''];
};

export function useEditFieldDialog({ field, onSubmit }) {
  const [name, setName] = useState('');
  const [type, setType] = useState('');
  const [options, setOptions] = useState(['']);

  useEffect(() => {
    if (!field) {
      return;
    }

    setName(field.display_name || field.name || '');
    setType(field.type || '');
    setOptions(getOptionValues(field.settings));
  }, [field]);

  const isOptionType = useMemo(() => OPTION_FIELD_TYPES.includes(type), [type]);

  const handleOptionChange = (index, value) => {
    setOptions((previousOptions) =>
      previousOptions.map((option, optionIndex) => (
        optionIndex === index ? value : option
      ))
    );
  };

  const handleDeleteOption = (index) => {
    setOptions((previousOptions) => (
      previousOptions.length === 1
        ? previousOptions
        : previousOptions.filter((_, optionIndex) => optionIndex !== index)
    ));
  };

  const handleAddOption = () => {
    setOptions((previousOptions) => [...previousOptions, '']);
  };

  const handleTypeChange = (event) => {
    const nextType = event.target.value;
    setType(nextType);

    if (!OPTION_FIELD_TYPES.includes(nextType)) {
      setOptions(['']);
      return;
    }

    setOptions((previousOptions) => (
      previousOptions.length ? previousOptions : ['']
    ));
  };

  const handleSubmit = () => {
    onSubmit({
      name: name.trim(),
      type,
      settings: isOptionType ? options : [],
    });
  };

  return {
    name,
    type,
    options,
    isOptionType,
    setName,
    handleOptionChange,
    handleDeleteOption,
    handleAddOption,
    handleTypeChange,
    handleSubmit,
  };
}
